import React from 'react'
import RichText from 'src/utils/RichText'
import Heading from 'src/utils/Heading'
import Button from 'src/utils/Button'

const OneColumnTextButton = ({ blok }) => {
    return (
        <div className="overflow-hidden">
            <div className="max-w-7xl mx-auto my-20 px-6 lg:px-12">
                <div className="max-w-[986px] mr-auto">
                    <Heading size="h2" className="lg:text-6xl md:text-5xl text-4xl !leading-tight">{blok.title}</Heading>
                    <div className="prose md:mt-12 mt-8 max-w-full">
                        <RichText>{blok.content}</RichText>
                    </div>
                    {blok.button_text &&
                        <Button to={blok.button_target?.cached_url} className="mt-12">
                            {blok.button_text}
                        </Button>
                    }
                </div>
            </div>
        </div>
    )
}

export default OneColumnTextButton